const btnClearFilterExpiredServices = {
  Typography: 'Clear'
};

export default btnClearFilterExpiredServices;
